import ContentError from 'components/ContentError'
import ContentLoading from 'components/ContentLoading'
import {
  DropdownItem,
  DropdownItemDescription,
  DropdownItemTitle,
  DropdownScroll,
} from 'components/Dropdown'
import Icon from 'components/Icon'
import { useBrandingSettings } from 'hooks/branding'
import { useActivation } from 'hooks/mobx-hooks'
import { observer } from 'mobx-react'
import React from 'react'
import { FilterSearchBar, FilterViewHeader } from '..'
import { InfiniteSelectFilter } from './InfiniteSelectFilter'
import InfiniteScrollLoader from '../../../components/InfiniteScrollLoader'

interface SelectFilterViewProps<TFilters extends Record<string, unknown>> {
  filter: InfiniteSelectFilter<keyof TFilters, any>
}

export const InfiniteSelectFilterView = observer(function NewSelectFilterView<
  TFilters extends Record<string, unknown>,
>({ filter }: SelectFilterViewProps<TFilters>) {
  const branding = useBrandingSettings()
  useActivation(filter)

  return (
    <>
      <FilterViewHeader
        title={filter.title}
        dataTest={'job-select-filter-clear-button'}
        onClear={() => {
          filter.clearValue()
          filter.stopEditing()
        }}
        onSelectAll={
          filter.allowSelectAll
            ? () => {
                filter.selectAll()
              }
            : undefined
        }
      />

      <FilterSearchBar onChange={(text) => filter.changeSearchText(text)} />

      <DropdownScroll>
        {filter.activate.match({
          pending: () => <ContentLoading compact />,
          rejected: (err: any) => <ContentError error={err} />,
          resolved: () =>
            filter.items.map((c, index) => (
              <DropdownItem
                key={`${c.title}-${index}`}
                data-test={'job-infinite-select-filter-option-' + c.title}
                onClick={() => filter.toggle(c.value)}
                icon={
                  <Icon
                    color={branding.themePrimary}
                    name={
                      filter.isSelected(c.value) ? 'checkbox' : 'checkbox-blank'
                    }
                  />
                }
              >
                <DropdownItemTitle>{c.title}</DropdownItemTitle>
                <DropdownItemDescription>
                  {c.description}
                </DropdownItemDescription>
              </DropdownItem>
            )),
        })}
        {filter.activate.resolved && (
          <InfiniteScrollLoader
            compact
            scrollProvider={filter.scrollProvider}
          />
        )}
      </DropdownScroll>
    </>
  )
})
